import {
  AsYouType,
  CountryCode,
  getCountries,
  parsePhoneNumberFromString,
} from 'libphonenumber-js';

function defaultCountry(country: string): CountryCode | undefined {
  return getCountries().find((code) => code === country.toUpperCase());
}

export function normalizeReservationPhone(
  value: string,
  country: string
): string | null {
  const trimmed = value.trim();
  if (!trimmed || !/^\+?[\d\s().-]+$/.test(trimmed)) return null;
  const code = defaultCountry(country) ?? 'AR';
  let parsed = parsePhoneNumberFromString(trimmed, code);
  if (
    code === 'AR' &&
    !trimmed.startsWith('+') &&
    !trimmed.startsWith('00') &&
    parsed?.country === 'AR' &&
    parsed.nationalNumber.length === 10
  )
    parsed = parsePhoneNumberFromString(`+549${parsed.nationalNumber}`);
  return parsed?.isValid() ? parsed.number : null;
}

export function formatReservationPhone(
  value: string | null | undefined,
  country: string
): string {
  if (!value) return '';
  const parsed = parsePhoneNumberFromString(value, defaultCountry(country));
  return parsed?.isValid() ? parsed.formatInternational() : value;
}

export function formatReservationPhoneInput(
  value: string,
  country: string
): string {
  return new AsYouType(defaultCountry(country)).input(value);
}

export function reservationPhoneDigits(value: string): string {
  return value.replace(/\D/g, '');
}
